// TODO: deprecate
import React, { Fragment } from 'react'
import { arrayOf, oneOfType, bool, func, shape, node } from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

import {
  ENABLE_FORCES_INPUT,
  ENABLE_VALIDATED_PROMO
} from '../../configuration/constants'
import { selectLabels } from '../../redux/configuration/selectors'
import {
  setDepartureRoute,
  setReturnRoute,
  setForcesBooking
} from '../../redux/ferryRouteSelections/actions'
import {
  selectDepartureDate,
  selectDepartureRoute,
  selectReturnDate,
  selectReturnRoute,
  selectForcesBooking
} from '../../redux/ferryRouteSelections/selectors'
import {
  clearPromoValidation,
  fetchPromoInformation
} from '../../redux/promo/actions'
import * as UserSelectionActions from '../../redux/userSelections/actions'
import { selectCurrentBookingPromoState } from '../../redux/selectors/selectCurrentBookingPromoState'
import FerryRoutesFormSelect from './elements/FerryRoutesFormSelect'
import FerryRoutesFormDateRangePicker from './elements/dates/FerryRoutesFormDateRangePicker'
import ValidatedPromoInput from '../ValidatedPromoInput/ValidatedPromoInput'
import WarningBanner from '../WarningBanner/WarningBanner'
import Checkbox from '../Checkbox/Checkbox'

const FerryRoutesRoundTripForm = ({
  availabilityErrors,
  openModal,
  closeModal,
  modalIsOpen,
  ferryRoutes,
  isPairRoutes,
  submit,
  enableRouteSelection
}) => {
  const dispatch = useDispatch()
  const activeDepartureRoute = useSelector(selectDepartureRoute)
  const activeReturnRoute = useSelector(selectReturnRoute)
  const departureDate = useSelector(selectDepartureDate)
  const returnDate = useSelector(selectReturnDate)
  const labels = useSelector(selectLabels)
  const forcesBooking = useSelector(selectForcesBooking)
  const promoInputState = useSelector(selectCurrentBookingPromoState)

  let isSubmitEnabled = false

  if (
    activeDepartureRoute &&
    activeDepartureRoute.code &&
    activeReturnRoute &&
    activeReturnRoute.code &&
    departureDate &&
    returnDate &&
    (!ENABLE_VALIDATED_PROMO ||
      promoInputState.valid === true ||
      promoInputState.valid === null ||
      promoInputState.code === '')
  ) {
    isSubmitEnabled = true
  }

  const handleDepartureRoute = routeData => {
    if (isPairRoutes) {
      if (String(routeData.code) !== String(activeDepartureRoute.code)) {
        if (activeDepartureRoute && activeDepartureRoute.code) {
          dispatch(setReturnRoute(activeDepartureRoute)) // TODO: Deprecate
          dispatch(
            UserSelectionActions.setReturnRoute(activeDepartureRoute.code)
          )
        } else {
          const firstAvailableRoute = ferryRoutes.find(
            route => route.code !== routeData.code
          )
          if (firstAvailableRoute) {
            dispatch(setReturnRoute(firstAvailableRoute)) // TODO: Deprecate
            dispatch(
              UserSelectionActions.setReturnRoute(firstAvailableRoute.code)
            )
          }
        }
      }
    }
    dispatch(setDepartureRoute(routeData)) // TODO: Deprecate
    dispatch(UserSelectionActions.setDepartureRoute(routeData.code))
  }

  const handleReturnRoute = routeData => {
    if (isPairRoutes) {
      if (String(routeData.code) !== String(activeReturnRoute.code)) {
        if (activeReturnRoute && activeReturnRoute.code) {
          dispatch(setDepartureRoute(activeReturnRoute)) // TODO: Deprecate
          dispatch(
            UserSelectionActions.setDepartureRoute(activeReturnRoute.code)
          )
        } else {
          const firstAvailableRoute = ferryRoutes.find(
            route => route.code !== routeData.code
          )
          if (firstAvailableRoute) {
            dispatch(setDepartureRoute(firstAvailableRoute)) // TODO: Deprecate
            dispatch(
              UserSelectionActions.setDepartureRoute(firstAvailableRoute.code)
            )
          }
        }
      }
    }
    dispatch(setReturnRoute(routeData)) // TODO: Deprecate
    dispatch(UserSelectionActions.setReturnRoute(routeData.code))
  }

  return (
    <div className="ferry-routes__form-round-trip">
      {!isEmpty(ferryRoutes) && (
        <div className="ferry-routes__form-routes">
          <FerryRoutesFormSelect
            activeRoute={activeDepartureRoute}
            ferryRoutes={ferryRoutes}
            fieldLabel={labels.departureRoute}
            toggleLabel={labels.change}
            updateRouteEvent={handleDepartureRoute}
            disableToggle={!enableRouteSelection}
          />
          <FerryRoutesFormSelect
            activeRoute={activeReturnRoute}
            ferryRoutes={ferryRoutes}
            fieldLabel={labels.returnRoute}
            toggleLabel={labels.change}
            updateRouteEvent={handleReturnRoute}
            disableToggle={!enableRouteSelection}
          />
        </div>
      )}

      <FerryRoutesFormDateRangePicker
        ferryLabels={labels}
        returnDateOnly={!enableRouteSelection}
        startDate={activeDepartureRoute.startDate}
        disabled={!activeDepartureRoute?.ferryId}
      />

      {ENABLE_VALIDATED_PROMO && (
        <div className="ferry-routes__validated-promo-container">
          <ValidatedPromoInput
            labels={labels}
            handleBlur={v => dispatch(UserSelectionActions.setPromoCode(v))}
            submitValidation={code => {
              dispatch(fetchPromoInformation(code))
            }}
            clearValidation={() => dispatch(clearPromoValidation())}
            {...promoInputState}
          />
        </div>
      )}

      {ENABLE_FORCES_INPUT && (
        <div className="ferry-routes__forces-input-container">
          <Checkbox
            name={'CF_BOOKING'}
            value={forcesBooking}
            label={labels.canadianForcesMember}
            disabled={false}
            onChange={v => {
              dispatch(setForcesBooking(v)) // TODO: Deprecate
              dispatch(UserSelectionActions.setIsForcesMember(v))
            }}
            formikCheckbox={false}
          />
        </div>
      )}

      {availabilityErrors?.length ? (
        <Fragment>
          {availabilityErrors.map((error, i) => (
            <WarningBanner key={error + i}>{error}</WarningBanner>
          ))}
        </Fragment>
      ) : null}
      <button
        className="ferry-routes__form-submit btn btn-primary large-primary-btn"
        onClick={submit}
        disabled={!isSubmitEnabled}
      >
        {labels.continueToPassengerInfoBtn} →
      </button>
    </div>
  )
}

FerryRoutesRoundTripForm.propTypes = {
  availabilityErrors: oneOfType([bool, arrayOf(node)]),
  openModal: func.isRequired,
  closeModal: func.isRequired,
  modalIsOpen: shape().isRequired,
  ferryRoutes: arrayOf(shape()).isRequired,
  isPairRoutes: bool,
  submit: func.isRequired,
  enableRouteSelection: bool.isRequired
}

export default FerryRoutesRoundTripForm
